import { orderBy } from 'lodash';
import { Tag } from './Tag';

type TagsLikeValue = string | Record<string, string>;

export class Tags {
    /**
     * @var array
     */
    private readonly tags: Record<string, string> = {};

    /**
     * @param tags
     */
    constructor(tags: TagsLikeValue) {
        if (tags) {
            if (typeof tags === 'string') {
                this.parse(tags);
            } else {
                this.tags = tags;
            }
        }
    }

    /**
     * Parse Tags
     * @param tags
     */
    public parse(tags: string): Tags {
        const lenTags = tags.length;

        let lastChar: string | null = null;
        let currentTag = new Tag();
        let jumper = 0;

        for (let i = 0, len = lenTags; i < len; i++) {
            const char = tags[i];
            const isEscaped = lastChar === '\\';

            if (char === '=' || char === ':') {
                if (jumper === 1 || isEscaped) {
                    currentTag.removeLastSlash();
                    currentTag.append(jumper, char);
                } else {
                    jumper = 1;
                }

                continue;
            }

            if (char === ';' || char === ',') {
                if (!isEscaped) {
                    this.add(currentTag);
                    currentTag = new Tag();
                    jumper = 0;
                    continue;
                }

                currentTag.removeLastSlash();
            }

            currentTag.append(jumper, char);
            lastChar = char;
        }

        this.add(currentTag);

        return this;
    }

    public add(currentTag: Tag): void {
        if (currentTag.key) {
            this.set(currentTag.key, currentTag.value ? currentTag.value : currentTag.key);
        }
    }

    /**
     * Set tag
     * @param name
     * @param value
     */
    public set(name: string, value: string): void {
        this.tags[name] = value;
    }

    /**
     * @return Tags
     * @param tagsValue
     */
    public static from(tagsValue: string): Tags {
        return new Tags(tagsValue);
    }

    /**
     * Get tag value
     * @param name
     * @param defaultValue
     */
    public get(name: string, defaultValue: string | null = null): string | null {
        return this.tags[name] ?? defaultValue;
    }

    /**
     * Convert to object
     */
    public toObject() {
        return { ...this.tags };
    }

    /**
     * Convert tags to string
     * @param separator
     */
    public toString(separator = ',') {
        return orderBy(Object.keys(this.tags))
            .reduce<string[]>(
                (current, key: string) => [...current, Tag.escape(key) + ':' + Tag.escape(this.tags[key])],
                [],
            )
            .join(separator);
    }
}
